export const DEFAULT_OPTIONS = [
  {
    id: 'name',
    label: 'Name',
    value: 'Name',
  },
  {
    id: 'medium',
    label: 'Medium',
    value: 'MessageMedium',
  },
  {
    id: 'date',
    label: 'Modified Date',
    value: 'UpdatedAt',
  },
];

export const LABEL_TEXT = 'Sort by';
